export const SET_SIGNERING_STATUS = "SET_ARRANGEMANG";
export const CLEAR_SIGNERING = "FETCH_DELTAGARE";
export const SET_ERROR = "SET_ERROR";
